import React, { useState, useEffect } from 'react';
import AddToCart from "../../../component/custom/AddToCart";
import AddPartAutoComplete from 'src/component/custom/AddPartAutoComplete'
import useReduxState from 'src/hooks/useReduxState';
import FadeInOut from "../../../component/Global/FadeInOut";
import PriceTable from "../../../component/custom/PriceTable";
import QuantityPicker from 'src/component/custom/QuantityPicker';
import Constants from 'src/helper/Constants';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import System from 'src/helper/system';

const CartManuallyAddPart = (props) => {
    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
    const [isObsoleteProduct, setIsObsoleteProduct] = useState(false);
    const [{ }, { get_inventory_by_id, get_pricing_by_id }] = useProductInventoryPriceStore();
    const { translation: t } = System;

    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { systemModules: { CART } } = Constants

    const inInsufficientQuantityMessageDisplayStatus = () => {
        if (productSelected && get_inventory_by_id(productSelected.ItemNumber) && get_pricing_by_id({ ItemNumber: productSelected.ItemNumber })) {
            return true;
        }
        return false;
    };

    const getSelectedProductInventory = () => {
        return get_inventory_by_id(productSelected.ItemNumber);
    };

    const getSelectedProductPricing = () => {
        if (productSelected?.ItemNumber) {
            return get_pricing_by_id({ ItemNumber: productSelected.ItemNumber })
        }
        return [];
    };
    const obsoleteProductValidationMessage = () => {
        return (
            <div className="text-red cart-head-input-error text-nowrap m-t-15">
                <b>{productSelected.ERPMFRPartNumber}:</b> {t('productObsoleteEnterAnotherPart')}
            </div>
        );
    };

    const fakePlaceHolder = () => {
        return (
            <>
                <div className="d-flex flex-column position-relative w200">
                    <div className="quantity w-auto clearfix" id='Quantity'>
                        <div className="quantity-picker disabled">
                            <div className="bs5 input-group flex-nowrap border-0">
                                <span className="bs5 input-group-prepend flex-nowrap">
                                    <button type="button" className="btn btn-outline-secondary btn-number br-0"
                                        data-type="minus" data-field="quant[1]" aria-label={t('decreaseQuantity')}>
                                        <span className="fa fa-minus"></span>
                                    </button>
                                </span>
                                <input type="text" name="quant[1]" className="form-control input-number"
                                    value="0" min="0" max="10" aria-labelledby="Quantity" onChange={() => { }} />
                                <span className="input-group-append">
                                    <button type="button" className="btn btn-outline-secondary btn-number bl-0"
                                        data-type="plus" data-field="quant[1]" aria-label={t('increaseQuantity')}>
                                        <span className="fa fa-plus"></span>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <button className="bs5 btn btn-secondary btn-sm w180 disabled h30">{t('updateCart')?.toUpperCase?.()}</button>
            </>
        );
    };

    useEffect(() => {
        productSelected?.ObsoleteFlag ? setIsObsoleteProduct(true) : setIsObsoleteProduct(false)
    }, [productSelected]);

    return (
        <>
            <FadeInOut show={true} duration={500} style={{}}>
                <div className="bs5 row">
                    <div className="col-12">
                        <div className="my-cart-head mt-2">
                            <div className="d-flex justify-content-start justify-content-md-between align-items-start flex-column flex-md-row">
                                <h4>{t('manuallyAddPart')}</h4>
                                <div>
                                    <AddPartAutoComplete fromComponent={Constants.CartType.MYCART} />
                                    {isObsoleteProduct &&
                                        <div className="d-flex">
                                            {obsoleteProductValidationMessage()}
                                        </div>
                                    }
                                </div>
                                {productSelected.ItemNumber &&
                                    <>
                                        <div className="d-flex flex-column position-relative w200">
                                            <QuantityPicker
                                                invalid_quantity_message_text={t('theQuantitySelectedDoesNotMeetMinMultReq')}
                                                showDisplayQtyMinQtyMult={true}
                                                disable_edit_force_default_quantity={true}
                                                readOnly_quantity={(!(
                                                    productSelected.ERPPartNumber || (productSelected.ERPPartNumber !== undefined || inInsufficientQuantityMessageDisplayStatus())
                                                )) || isObsoleteProduct}
                                                single_product_inventory={getSelectedProductInventory()}
                                                single_product={productSelected}
                                                force_default_quantity={productSelected?.QtyMin}
                                                single_product_pricing_list={getSelectedProductPricing()}
                                                isFrom={CART}

                                            />
                                            <div style={{ display: "none" }}>
                                                <PriceTable
                                                    single_product_pricing_list={getSelectedProductPricing()}
                                                    single_product_inventory={getSelectedProductInventory()}
                                                    single_product={productSelected} />
                                            </div>
                                        </div>
                                        <div style={{ visibility: 'visible' }} className={'spinner-loader'}>
                                            <AddToCart
                                                dontOpenAddedToCartPopup={true}
                                                productAddedToCartCallback={() => {
                                                    system_alert_indicator({
                                                        name: 'addPartToCart',
                                                        message: t('partHasBeenSuccessfullyAddedToYourCart'),
                                                        type: "success"
                                                    })
                                                    setProductSelected({})
                                                    setSearchTerm('')
                                                    setTimeout(() => {
                                                        document.body.style.overflow = '';
                                                    }, 400)
                                                }}
                                                single_product_pricing_list={getSelectedProductPricing()}
                                                single_product_inventory={getSelectedProductInventory()}
                                                single_product={productSelected}
                                                isFrom={CART}
                                                isFromManualCart={true}
                                                isObsoleteProduct={isObsoleteProduct}
                                            />
                                        </div>
                                    </>
                                }
                                {!productSelected.ItemNumber &&
                                    <>
                                        {fakePlaceHolder()}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </FadeInOut>
        </>
    );
}

export default CartManuallyAddPart;